module.exports = __webpack_public_path__ + "img/btn03.62b34ddb.svg";